export class InvtOrderListModel {
    code_no: number
    code_name: string
    item_desc: string

    constructor(
        code_no: number,
        code_name: string,
        item_desc: string,
    ) {
        this.code_no = code_no
        this.code_name = code_name
        this.item_desc = item_desc
    }
}